// src/lib/supabase.js
import { createClient } from "@supabase/supabase-js";

// CRA / Vite（你用 CRA）會把 REACT_APP_ 開頭的變數注入瀏覽器端
const url = process.env.REACT_APP_SUPABASE_URL;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: false, // 你沒有用登入，關掉持久化比較單純
    autoRefreshToken: false,
  },
});
